import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { Button, Props as ButtonProps } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';
import { TextInput } from '@/components/text-input';

interface Props {
  children?: React.ReactNode;
  containerStyle?: StyleProp<ViewStyle>;
  deleteButtonProps?: ButtonProps;
  initialName?: string;
  inputError?: string;
  isSaving?: boolean;
  nameInputLabel: string;
  onChangeText?: (text: string) => void;
  onSave: (name: string) => void;
  saveButtonText?: string;
}

export const OrderGuideActionSheetNameInput: React.FC<Props> = ({
  children,
  containerStyle,
  deleteButtonProps,
  initialName,
  nameInputLabel,
  isSaving,
  onSave,
  saveButtonText = i18n.t('save'),
  inputError,
  onChangeText,
}) => {
  const [styles] = useStyles();

  const [name, setName] = useState(initialName ?? '');

  return (
    <>
      <View
        style={[
          inputError ? styles.inputError : styles.inputNoError,
          containerStyle,
        ]}
      >
        <TextInput
          autoCapitalize="none"
          autoComplete="off"
          containerStyle={styles.inputContainer}
          error={inputError}
          label={name ? nameInputLabel : null}
          onChangeText={(value) => {
            onChangeText?.(value);
            setName(value);
          }}
          placeholder={nameInputLabel}
          value={name}
        />
        {children}
      </View>
      <Button
        disabled={!name}
        loading={isSaving}
        onPress={() => onSave(name.trim())}
        trackingData={{ name: 'order_guide_action_sheet_input.save_button' }}
      >
        {saveButtonText}
      </Button>
      {deleteButtonProps ? (
        <View style={styles.deleteButtonContainer}>
          <Button type="danger" {...deleteButtonProps} />
        </View>
      ) : null}
    </>
  );
};

const useStyles = createStyles((theme) => ({
  deleteButtonContainer: {
    marginTop: 12,
  },
  inputContainer: {
    borderColor: theme.colors.stroke,
  },
  inputError: {
    marginBottom: 12,
  },
  inputNoError: {
    marginBottom: 32,
  },
}));
